import React, {useState, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import logo from '../../assets/images/nls-logo.png';
import {Button, Input} from '../../components';
import {useMutation} from 'react-query';
import toast from 'react-hot-toast';

import {forgotPasswordApi} from '@apis/';

const ForgotPassword = () => {
  const {t} = useTranslation();
  const [email, setEmail] = useState('');

  const history = useHistory();

  const forgotPassword = useMutation(params => forgotPasswordApi(params));

  useEffect(() => {
    if (forgotPassword?.isError) {
      if (typeof forgotPassword?.error === 'string') {
        toast.error(forgotPassword?.error);
      } else {
        toast.error(t('auth.tokenError'));
      }
      forgotPassword?.reset();
    }

    if (forgotPassword?.isSuccess) {
      toast.success(t('auth.resetLinkSuccess'));
      history.push('/email-sent');
    }
  }, [email, forgotPassword, history, t]);

  const handleReset = async e => {
    if (email === '' || email === null) {
      toast.error(t('auth.enterEmailAddress'));
      return;
    }
    e.preventDefault();
    await forgotPassword.mutateAsync({
      email,
    });
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleReset(e);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-6xl flex flex-col lg:flex-row bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Left Panel - Form */}
        <div className="flex-1 lg:w-auto next-gradient relative p-6 sm:p-8 lg:p-16 min-h-screen lg:min-h-0 flex flex-col justify-center">
          {/* Form Content */}
          <div className="w-full max-w-md mx-auto">
            <div className="text-center mb-8">
              <h1 className="font-bold text-2xl sm:text-3xl text-white">
                {t('auth.resetPasswordTitle')}
              </h1>
              <p className="font-light text-xs sm:text-sm text-white mt-3 px-4">
                {t('auth.resetPasswordDesc')}
              </p>
            </div>

            <div className="space-y-4 mb-8">
              <Input
                dark
                white
                value={email}
                onChange={e => setEmail(e.target.value)}
                label={t('auth.email')}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div className="space-y-4">
              <Button
                block
                label={t('auth.resetMyPassword')}
                onClick={handleReset}
                loading={forgotPassword?.isLoading}
                disabled={forgotPassword?.isLoading || !email}
              />

              <div className="text-center space-y-2">
                <div>
                  <p className="text-white text-xs">
                    {t('auth.dontHaveAccount')}
                  </p>
                  <Link
                    to="/register"
                    className="text-white text-xs underline ml-1">
                    {t('auth.signUpNow')}
                  </Link>
                </div>
                <div>
                  <p className="text-white text-xs">
                    {t('auth.alreadyHaveAccount')}
                  </p>
                  <Link to="/" className="text-white text-xs underline ml-1">
                    {t('auth.signInNow')}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel - Logo (hidden on small screens, visible on lg+) */}
        <div className="hidden lg:flex lg:w-96 xl:w-[400px] justify-center items-center next-gradient p-8">
          <img
            className="object-contain max-w-full max-h-80"
            src={logo}
            alt="Next Level Technology Logo"
          />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
